export const SUMMARY_NAMES_LIMIT = 3

export interface GroupSummary {
  enabled: number
  // Note: how many enabled switches are left out of `names`
  more: number
  names: string[]
  total: number
}

export const getGroupSummary = (
  labels: Record<string, string>,
  values: Record<string, unknown>,
) => {
  const keys = Object.keys(labels)
  const enabledKeys = keys.filter((key) => values[key])

  return {
    enabled: enabledKeys.length,
    more: Math.max(enabledKeys.length - SUMMARY_NAMES_LIMIT, 0),
    names: enabledKeys.slice(0, SUMMARY_NAMES_LIMIT).map((key) => labels[key]),
    total: keys.length,
  } satisfies GroupSummary
}
